import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { classifierViewFields } from '../../constants/classifier';

export default createValidation([
  {
    name: classifierViewFields.PRICE,
    validators: (field) => validatorRequired()(field),
  },
]);
